import { createFileRoute } from '@tanstack/react-router';
import { useSuspenseQuery } from '@apollo/client';
import { creatorDocument } from '@social-garden/api/documents/creator.ts';
import { Container, Grid } from '@mui/material';
import CreatorDetailsHeader from '@/components/CreatorDetails/CreatorDetailsHeader.tsx';
import CreatorDetailsChannels from '@/components/CreatorDetails/CreatorDetailsChannels.tsx';
import CreatorDetailsCollaboratedBrands from '@/components/CreatorDetails/CreatorDetailsCollaboratedBrands.tsx';
import CreatorDetailsCollaborations from '@/components/CreatorDetails/CreatorDetailsCollaborations.tsx';

export const Route = createFileRoute('/_manager/_app/creators/$id/')({
  component: CreatorDetails,
});

function CreatorDetails() {
  const { id } = Route.useParams();

  const {
    data: { creator },
  } = useSuspenseQuery(creatorDocument, {
    variables: {
      id,
    },
  });

  return (
    <Container>
      <Grid container spacing={4}>
        <Grid size={12}>
          <CreatorDetailsHeader creator={creator} />
        </Grid>
        <Grid size={12}>
          <CreatorDetailsChannels channels={creator.channels} />
        </Grid>
        <Grid size={12}>
          <CreatorDetailsCollaboratedBrands creatorId={creator.id} />
        </Grid>
        <Grid size={12}>
          <CreatorDetailsCollaborations creatorId={creator.id} />
        </Grid>
      </Grid>
    </Container>
  );
}
